import React from 'react'
import { useSeo } from '../../lib/i18n'

export default function BetingelserEn() {
  useSeo({
    title: 'Terms & Conditions | Borgs Driving School Kalundborg',
    description: 'Standard terms and conditions for Borgs Driving School. Read about instruction, payments, cancellations, and tests.',
    lang: 'en',
    pathname: '/en/terms'
  })

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Terms &amp; Conditions
            </h1>
            <p className="mt-2 text-slate-700 font-semibold text-lg">
              General business terms for Borgs Driving School I/S
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                1. Instruction
              </h2>
              <p>
                The student participates actively in the training through personal attendance at both theoretical and practical lessons.
              </p>
              <p>
                If the student is unable to attend theoretical instruction, the school/instructor must be notified. Danish law allows a student to complete 1 theory evening as self-study.
              </p>
              <p>
                Because statutory regulations require theory to be conducted as classroom teaching, regular attendance is essential.
              </p>
              <p>
                The student coordinates with the instructor regarding when practical driving lessons take place, as well as pick-up and drop-off locations.
              </p>
              <p>
                Cancellation of practical lessons must be made the day before by 12:00 PM at the latest to avoid being charged for the lesson(s).
              </p>
              <p>
                Refer to the reverse side of the official lesson plan regarding the consequences of interruptions or pauses in driver training.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                2. Payment
              </h2>
              <p>
                Payment is made according to forwarded / issued invoices.
              </p>
              <p>
                Instruction is typically paid in installments. <strong>All invoices must be settled in full before the practical test can be conducted.</strong> All prices include Danish VAT (moms).
              </p>
              <p>
                Official test fees to the Road Safety Agency are VAT-exempt.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                3. Changed or Interrupted Course
              </h2>
              <p>
                In the event of a changed or discontinued course, unconsumed prepaid lessons are refunded.
              </p>
              <p>
                If the student has received instruction that has not been prepaid, the official lesson plan is only released upon settlement for instruction received.
              </p>
              <p>
                For discounted packages, the discount is considered applied to the final lessons free of charge. If a dispute arises between student and driving school, the student may appeal to the Danish Driving Instruction Appeals Board (Ankenævn for Køreundervisning). The fee is 150 DKK and is refunded if the complaint is upheld.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                4. Test Dates and Administration
              </h2>
              <p>
                Test times are allocated by the Danish Road Safety Agency (Færdselsstyrelsen) and generally cannot be modified once booked.
              </p>
              <p>
                The driving instructor determines when a student is sufficiently prepared for the theoretical / practical test.
              </p>
              <p>
                The driving school cannot be held liable for waiting times on test dates or delays in medical certificate approvals. The school cannot be held financially responsible if a student fails a test.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                5. Test Registration
              </h2>
              <p>
                The driving school handles the official test scheduling with the Danish Road Safety Agency.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
